import React from 'react';
import './Home.css'; // Asegúrate de tener este archivo si deseas usar Home.css
import Ayuntamiento from './Ayuntamiento';
import ActualidadNav from './ActualidadNav/ActualidadNav';

const Home = () => {
    return (
        <div className="home-container"> {/* Contenedor principal para estilos */}
            <div className="home-section carousel-section"> {/* Sección Ayuntamiento (Carrusel) - PRIMERO */}
                <Ayuntamiento />
            </div>
            <div className="home-section">
                <h2 className="home-section-title">Noticias Escalonilla</h2>
                <ActualidadNav />
            </div>
        </div>
    );
};

export default Home;
